import { createFileRoute, Outlet, Link, useLocation } from "@tanstack/react-router";
import { cn } from "@/lib/utils";
import { Key, HeartPulse, LayoutDashboard, Gauge } from "lucide-react";

export const Route = createFileRoute("/admin/ops/ai")({
  component: AdminAILayout,
});

const tabs = [
  { to: "/admin/ops/ai/providers", label: "Proveedores", icon: Key },
  { to: "/admin/ops/ai/health", label: "Salud", icon: HeartPulse },
  { to: "/admin/ops/ai/dashboard", label: "Panel", icon: LayoutDashboard },
  { to: "/admin/ops/ai/executive", label: "Asesora", icon: Gauge },
];

function AdminAILayout() {
  const loc = useLocation();
  return (
    <div className="flex h-full flex-col">
      <div className="border-b px-6 pt-4">
        <h1 className="mb-3 text-base font-semibold">Centro de control IA</h1>
        <Link
          to="/admin"
          search={{ tab: "renata" } as never}
          className="mb-2 inline-flex text-xs text-muted-foreground hover:text-foreground"
        >
          ← Renata / IA
        </Link>
        <nav className="flex gap-1">
          {tabs.map((t) => {
            const active = loc.pathname.startsWith(t.to);
            return (
              <Link
                key={t.to}
                to={t.to}
                className={cn(
                  "flex items-center gap-1.5 rounded-t-md px-3 py-1.5 text-sm transition-colors",
                  active
                    ? "border-b-2 border-violet-600 text-violet-700 dark:text-violet-300 font-medium"
                    : "text-muted-foreground hover:text-foreground",
                )}
              >
                <t.icon className="h-3.5 w-3.5" />
                {t.label}
              </Link>
            );
          })}
        </nav>
      </div>
      <div className="flex-1 overflow-y-auto">
        <Outlet />
      </div>
    </div>
  );
}
